import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function CerezPolitikasiPage() {
  return (
    <div className="min-h-screen bg-gray-50 font-poppins">
      <Header />

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
              Çerez Politikası
            </h1>

            <div className="space-y-8 text-gray-600">
              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Çerez Nedir?</h2>
                <p>
                  Çerezler (cookies), internet sitelerini ziyaret ettiğinizde tarayıcınız aracılığıyla 
                  cihazınıza (bilgisayar, telefon, tablet) kaydedilen küçük metin dosyalarıdır. 
                  Çerezler, web sitesinin daha verimli çalışmasını sağlar ve size daha iyi bir 
                  kullanıcı deneyimi sunar.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Çerez Türleri</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="bg-gold-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Gerekli Çerezler</h3>
                    <p className="text-sm">
                      Web sitesinin temel işlevlerini yerine getirmesi için zorunlu olan çerezlerdir. 
                      Bu çerezler olmadan site düzgün çalışmaz.
                    </p>
                  </div>
                  
                  <div className="bg-gold-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Performans Çerezleri</h3>
                    <p className="text-sm">
                      Web sitesinin performansını ölçmek ve iyileştirmek için kullanılan çerezlerdir. 
                      Sayfa görüntüleme sayıları ve trafik kaynakları hakkında bilgi toplar.
                    </p>
                  </div>
                  
                  <div className="bg-gold-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">İşlevsellik Çerezleri</h3>
                    <p className="text-sm">
                      Tercihlerinizi hatırlayarak size daha kişiselleştirilmiş bir deneyim sunan çerezlerdir. 
                      Dil seçimi, kullanıcı adı gibi bilgileri saklar.
                    </p>
                  </div>
                  
                  <div className="bg-gold-50 p-4 rounded-lg">
                    <h3 className="font-semibold text-gray-800 mb-2">Hedefleme Çerezleri</h3>
                    <p className="text-sm">
                      İlgi alanlarınıza uygun reklamlar göstermek için kullanılan çerezlerdir. 
                      Gezinme davranışınızı takip ederek ilginizi çekebilecek içerikleri sunar.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Sitemizdeki Çerezler</h2>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <div className="space-y-4">
                    <div>
                      <h4 className="font-medium text-gray-800">Oturum Çerezleri</h4>
                      <p className="text-sm text-gray-600">
                        Alışveriş sepetinizi hatırlamamız ve güvenli giriş yapmanız için gereklidir.
                      </p>
                    </div>
                    
                    <div>
                      <h4 className="font-medium text-gray-800">Tercih Çerezleri</h4>
                      <p className="text-sm text-gray-600">
                        Dil, para birimi ve diğer tercihlerinizi hatırlamamız için kullanılır.
                      </p>
                    </div>
                    
                    <div>
                      <h4 className="font-medium text-gray-800">Analitik Çerezler</h4>
                      <p className="text-sm text-gray-600">
                        Google Analytics gibi araçlarla site kullanımını analiz etmek için kullanılır.
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Çerez Yönetimi</h2>
                <div className="space-y-4">
                  <p>
                    Çerezleri kontrol etmek için tarayıcınızın ayarlarını kullanabilirsiniz. 
                    Çoğu tarayıcı çerezleri otomatik olarak kabul eder, ancak bu ayarı değiştirebilirsiniz.
                  </p>
                  
                  <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-400">
                    <p className="text-sm text-amber-800">
                      <strong>Önemli:</strong> Çerezleri devre dışı bırakırsanız, site bazı özelliklerinin 
                      düzgün çalışmaması mümkündür.
                    </p>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h4 className="font-medium text-gray-800 mb-2">Chrome</h4>
                      <p className="text-sm text-gray-600">
                        Ayarlar &gt; Gelişmiş &gt; Gizlilik ve güvenlik &gt; Site ayarları &gt; Çerezler
                      </p>
                    </div>
                    
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h4 className="font-medium text-gray-800 mb-2">Firefox</h4>
                      <p className="text-sm text-gray-600">
                        Seçenekler &gt; Gizlilik ve güvenlik &gt; Çerezler ve site verileri
                      </p>
                    </div>
                    
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h4 className="font-medium text-gray-800 mb-2">Safari</h4>
                      <p className="text-sm text-gray-600">
                        Tercihler &gt; Gizlilik &gt; Çerezler ve web sitesi verileri
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Üçüncü Taraf Çerezler</h2>
                <p>
                  Sitemizde Google Analytics, Facebook Pixel gibi üçüncü taraf servislerinin 
                  çerezleri kullanılabilir. Bu çerezler, ilgili şirketlerin gizlilik politikalarına tabidir.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">İletişim</h2>
                <div className="bg-gold-50 p-6 rounded-lg">
                  <p className="text-gray-600 mb-4">
                    Çerez politikamız hakkında sorularınız için:
                  </p>
                  <div className="space-y-2 text-gray-700">
                    <p><strong>Emin Kuyumculuk</strong></p>
                    <p><strong>Adres:</strong> Kamil Ocak Mah. Divrik Cad. 45/A Keçiören / ANKARA</p>
                    <p><strong>Telefon:</strong> 0531 603 68 91</p>
                    <p><strong>E-posta:</strong> info@eminkuyumculuk.com.tr</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-700 mb-4">Güncellemeler</h2>
                <p>
                  Bu çerez politikası, yasal düzenlemeler ve iş uygulamalarındaki değişiklikler 
                  doğrultusunda güncellenebilir. Güncellemeler bu sayfada yayınlanacaktır.
                </p>
                <p className="text-sm text-gray-500 mt-2">
                  <strong>Son güncelleme:</strong> {new Date().toLocaleDateString('tr-TR')}
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}